import { useEffect } from "react";
import AllRoutes from "./compoonents/AllRoutes";
import Footer from "./compoonents/Footer";
import Header from "./compoonents/Header";
import { mensData } from "./compoonents/MensData";

function App() {
  useEffect(() => {
    localStorage.setItem("mensData", JSON.stringify(mensData));
  }, []);
  return (
    <div className="main">
      <Header />
      <AllRoutes />
      <Footer />
    </div>
  );
}

export default App;
